module.exports = "./dist/film.svg?b95c11010b920f6c966f1d4637a9ff47";


//////////////////
// WEBPACK FOOTER
// ./src/img/film.svg
// module id = 95
// module chunks = 0